import IceBreakerCRUDActions from '../actions/IceBreakerCRUDActions';
import Actions from '../actions/actions';
import { cloneDeep, unionBy } from 'lodash';
import { setBusy, setUnBusy } from './common/commonReducers';
import { IceBreakerState } from '../interfaces/iceBreakers';
import ButtonActions from '../actions/IceBreakerButtonCRUDActions';
import { IceBreakerKind, IceBreakerModel } from '../model/IceBreakerModel';

const initialState: IceBreakerState = {
  busy: false,
  facebook: { entities: [] },
  instagram: { entities: [] },
};

const retrievedAll = (
  state: IceBreakerState,
  action: { kind: IceBreakerKind; entities: IceBreakerModel[] },
  shouldMerge: boolean,
) => {
  const newState = cloneDeep(state);
  const { entities, kind } = action;
  newState.busy = false;
  if (shouldMerge) {
    newState[kind].entities = unionBy(entities, newState[kind].entities, 'id');
  } else {
    newState[kind].entities = entities;
  }
  return newState;
};

const update = (
  state: IceBreakerState,
  action: { entity: IceBreakerModel },
) => {
  const {
    entity,
    entity: { kind },
  } = action;
  const newState = cloneDeep(state);
  const entityIndex = newState[kind].entities.findIndex(
    e => e.id === entity.id,
  );
  if (entityIndex === -1) {
    newState[kind].entities.push(entity);
  } else {
    newState[kind].entities[entityIndex] = entity;
  }

  newState.busy = false;
  return newState;
};

export function iceBreakers(state = initialState, action: any) {
  switch (action.type) {
    case IceBreakerCRUDActions.busyAction:
      return setBusy(state);
    case IceBreakerCRUDActions.unbusyAction:
      return setUnBusy(state);
    case IceBreakerCRUDActions.retrievedAllAction:
      return retrievedAll(state, action, false);
    case IceBreakerCRUDActions.updateAction:
      return update(state, action);
    case ButtonActions.busyAction:
      return setBusy(state);
    case ButtonActions.retrievedAction: {
      const newState = cloneDeep(state);
      const { iceBreakerId, button } = action.payload;
      const allEntities = [
        ...newState.facebook.entities,
        ...newState.instagram.entities,
      ];
      newState.busy = false;

      const iceBreakerInstance = allEntities.find(e => e.id === iceBreakerId);

      if (iceBreakerInstance) {
        iceBreakerInstance.buttons.push(button);
      }

      return newState;
    }
    case ButtonActions.updateAction: {
      const newState = cloneDeep(state);
      newState.busy = false;
      const { iceBreakerId } = action.entity;
      const entityCopy = cloneDeep(action.entity);
      delete entityCopy.widgetId;
      const allEntities = [
        ...newState.facebook.entities,
        ...newState.instagram.entities,
      ];

      const iceBreakerInstance = allEntities.find(e => e.id === iceBreakerId);

      if (iceBreakerInstance) {
        const buttonIndex = iceBreakerInstance.buttons.findIndex(
          b => b.id === entityCopy.id,
        );
        if (buttonIndex !== -1) {
          iceBreakerInstance.buttons[buttonIndex] = entityCopy;
        }
      }

      return newState;
    }
    case ButtonActions.deleteLocalAction: {
      const newState = cloneDeep(state);
      newState.busy = false;
      const { iceBreakerId } = action.entity;
      const allEntities = [
        ...newState.facebook.entities,
        ...newState.instagram.entities,
      ];

      const iceBreakerInstance = allEntities.find(e => e.id === iceBreakerId);

      if (iceBreakerInstance) {
        const buttonIndex = iceBreakerInstance.buttons.findIndex(
          b => b.id === action.entity.id,
        );
        if (buttonIndex !== -1) {
          iceBreakerInstance.buttons.splice(buttonIndex, 1);
        }
      }

      return newState;
    }
    case Actions.RESET:
      return initialState;
    case Actions.UNBUSY:
      return { ...state, busy: false };
    default:
      return state;
  }
}
